export default __webpack_public_path__ + "static/media/hht1_ep10_timeline_q01_b.90d64dfc.png";